import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"

import { Guid, IApiLink } from "@/types"
import ImageCollection, { IGetImageCollectionDto } from "./ImageCollection"

export enum AssetInspectionType {
    delivery = "delivery",
    return = "return",
}

export interface IGetAssetInspectionDTO {
    id: Guid
    assetId: Guid
    reservationId: Guid
    shippingOrderId: Guid
    inspectionType: AssetInspectionType
    inspectionDate: string
    inspectedBy: Guid
    damages: boolean
    isOperational: boolean
    condition: number
    fuel?: number | null
    operationHours?: number | null
    adBlue?: number | null
    refuel?: number | null
    lsva?: number | null
    mileage?: number | null
    comment?: string | null
    images: IGetImageCollectionDto
    links?: IApiLink[]
}

export interface ICreateAssetInspectionDTO {
    assetId: Guid
    shippingOrderId: Guid
    damages: boolean
    isOperational: boolean
    condition: number
    fuel?: number | null // required for machines
    operationHours?: number | null // required for machines
    adBlue?: number | null
    refuel?: number | null
    lsva?: number | null
    mileage?: number | null
    comment?: string | null
    imageCollectionId: Guid
    inspectionDate: string
}

export interface IUpdateAssetInspectionDTO {
    damages: boolean
    isOperational: boolean
    condition: number
    fuel?: number | null // required for machines
    operationHours?: number | null // required for machines
    adBlue?: number | null
    refuel?: number | null
    lsva?: number | null
    mileage?: number | null
    comment?: string | null
}

export interface IUpdateAssetInspectionCommentDTO {
    comment?: string | null
}

export default class AssetInspection {
    id: Guid
    assetId: Guid
    reservationId: Guid
    shippingOrderId: Guid
    inspectionType: AssetInspectionType
    inspectionDate: Dayjs
    inspectedByUserEmail: string
    damages: boolean
    isOperational: boolean
    condition: number
    fuel?: number
    operationHours?: number
    adBlue?: number
    refuel?: number
    lsva?: number
    mileage?: number
    comment?: string | null
    images: ImageCollection
    linkUpdateInspection?: IApiLink
    linkUpdateInspectionComment?: IApiLink

    constructor(dto: IGetAssetInspectionDTO, {
        inspectedByUserEmail,
    }: {
        inspectedByUserEmail: string
    }) {
        this.id = dto.id
        this.assetId = dto.assetId
        this.reservationId = dto.reservationId
        this.shippingOrderId = dto.shippingOrderId
        this.inspectionType = dto.inspectionType
        this.inspectionDate = dayjs(dto.inspectionDate).local()
        this.inspectedByUserEmail = inspectedByUserEmail
        this.damages = dto.damages
        this.isOperational = dto.isOperational
        this.condition = dto.condition
        this.fuel = dto.fuel ?? undefined
        this.operationHours = dto.operationHours ?? undefined
        this.adBlue = dto.adBlue ?? undefined
        this.refuel = dto.refuel ?? undefined
        this.lsva = dto.lsva ?? undefined
        this.mileage = dto.mileage ?? undefined
        this.comment = dto.comment
        this.images = new ImageCollection(dto.images)
        this.linkUpdateInspection = dto.links?.find(link => link.entity === ApiLinkEntity.assetInspection && link.rel === ApiLinkRel.partialUpdate)
        this.linkUpdateInspectionComment = dto.links?.find(link => link.entity === ApiLinkEntity.assetInspectionComment && link.rel === ApiLinkRel.update)
    }
}
